import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { useLang } from "@/i18n";

const routes = [
  {
    path: "/product/:siteCode",
    name: "product",
    component: () => import("@/views/product"),
  },
  {
    path: "/question/:siteCode/:productId",
    name: "question",
    component: () => import("@/views/question"),
  },
  {
    path: "/plan/:siteCode/:questionId",
    name: "plan",
    component: () => import("@/views/plan"),
  },
  {
    path: "/h5",
    name: "h5",
    children: [
      {
        name: "h5-product",
        path: "/h5/product/:siteCode",
        component: () => import("@/views/h5/product/MobileIndex"),
      },
      {
        path: "/h5/question/:siteCode/:productId",
        name: "h5-question",
        component: () => import("@/views/h5/question"),
      },
      {
        path: "/h5/plan/:siteCode/:questionId",
        name: "h5-plan",
        component: () => import("@/views/h5/plan"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from, next) => {
  if (!store.state.baseUrl) {
    await store.dispatch("onGetBasic");
  }
  //获取站点列表
  store.state.siteList.length === 0 && (await store.dispatch("onGetSiteList"));
  //获取站点按钮语言配置
  store.state.siteSetting.length === 0 &&
    (await store.dispatch("onGetSiteSettings"));
  // 选择站点
  if (to.params.siteCode) {
    store.commit("SET_SITECODE", to.params.siteCode);
    useLang(to.params.siteCode);
  }
  // 选择产品清空缓存问题
  if (to.name === "product" || to.name === "h5-product") {
    store.commit("SET_CHECKED_QUES", null);
  }

  //判断地址路径中是否包含/h5
  const pathList = to.path.split("/");
  const isNowH5 = pathList.includes("h5");
  //手机端没有/h5标识的添加/h5标识;PC端含有/h5标识的移除
  if (isMobile()) {
    if (!isNowH5) {
      next(`/h5${to.path}`);
    } else {
      next();
    }
  } else {
    if (!isNowH5) {
      next();
    } else {
      next(`${to.path.replace("/h5", "")}`);
    }
  }
});
//判断是否是手机端
const isMobile = () =>
  navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );

export default router;
